import { splitGrapheme } from "../../../lib/wordGenerator/splitGrapheme";
import { CandidateCharactersFilter } from "../../../param/generalSearchFilter";
import { filter } from "../commonLoop";
import { Result } from "../generalSearchResult";

export const candidateCharactersFilter = async ({
  query,
  result,
  workerContext,
}: {
  query: CandidateCharactersFilter;
  result: Result;
  workerContext: any;
}) => {
  if ((query.candidateType ?? "candidate") === "candidate") {
    let exceptionsCount = 0;
    let characters = query.characters;
    if (query.characters.match(/\+(\d)+$/g)) {
      exceptionsCount = parseInt(
        query.characters.match(/\+(\d)+$/g)![0].slice(1)
      );
      characters = query.characters.replace(/\+(\d)+$/g, "");
    }
    const set = new Set(splitGrapheme(characters));
    return filter(workerContext, result, (e) => {
      let flag = true;
      let counter = 0;
      for (const c of e.currentWord) {
        if (!set.has(c)) {
          ++counter;
          if (counter > exceptionsCount) {
            flag = false;
            break;
          }
        }
      }
      return flag;
    });
  } else if (query.candidateType === "included") {
    return filter(workerContext, result, (e) => {
      let exceptionsCount = 0;
      let characters = query.characters;
      if (query.characters.match(/-(\d)+$/g)) {
        exceptionsCount = parseInt(
          query.characters.match(/-(\d)+$/g)![0].slice(1)
        );
        characters = query.characters.replace(/-(\d)+$/g, "");
      }

      const counterTable = splitGrapheme(characters).reduce(
        (table: Record<string, number>, c: string) => {
          table[c] = (table[c] ?? 0) + 1;
          return table;
        },
        {} as Record<string, number>
      );

      const wordCount = splitGrapheme(e.currentWord).reduce(
        (table: Record<string, number>, c: string) => {
          table[c] = (table[c] ?? 0) + 1;
          return table;
        },
        {} as Record<string, number>
      );

      let flag = true;
      let counter = 0;
      for (const key in counterTable) {
        if (counterTable[key] > (wordCount[key] ?? 0)) {
          counter += counterTable[key] - (wordCount[key] ?? 0);
          if (counter > exceptionsCount) {
            flag = false;
            break;
          }
        }
      }
      return flag;
    });
  } else if (query.candidateType === "excluded") {
    return filter(workerContext, result, (e) => {
      const set = new Set(splitGrapheme(query.characters));
      let flag = true;
      for (const c of e.currentWord) {
        if (set.has(c)) {
          flag = false;
          break;
        }
      }
      return flag;
    });
  } else if (query.candidateType === "supersequence") {
    return filter(workerContext, result, (e) => {
      const flag = new RegExp(splitGrapheme(query.characters).join(".*")).test(
        e.currentWord
      );
      return flag;
    });
  } else if (query.candidateType === "subsequence") {
    return filter(workerContext, result, (e) => {
      const flag = new RegExp(
        "^" + splitGrapheme(query.characters).join("?") + "?$"
      ).test(e.currentWord);
      return flag;
    });
  }
  return result;
};
